/* @flow strict */

import * as React from 'react';
import _ from 'lodash';
import { EventDetailContainerContext } from '/client/src/contexts/EventDetailContainer';
import EventPageDetailCustomersModal from './tableViewModal';
import EventPageDetailLinksModal from './fileLinksModal';
import useOutsideClick from 'client/src/utils/useOutsideClick';
import Credentials from '/client/src/api/Credentials.js';
import { exportAttendees } from '/client/src/utils/export';
import { CTooltipText } from '/client/src/components/tooltip/';
import CssPinner from '../../../../components/csspinner';


type PropsType = {
  subViewTab?: string,
  eventId: string | number,
  handleTriggerChangeTableContent: () => void,
  handleSearch: (string) => void,
  setRowsFilter: (string) => void,
  rowsFilter: {[any]: boolean}
};

const EventPageDetailCustomersSearchbar = ({
  subViewTab,
  eventId,
  handleTriggerChangeTableContent,
  handleSearch,
  setRowsFilter,
  rowsFilter
}: PropsType): React.Element<'div'> => {
  const context = React.useContext(EventDetailContainerContext);
  const [showExportDrop, handleShowExportDrop] = React.useState(false);
  const [showtableViewModal, handleShowtableViewModal] = React.useState(false);
  const [searchString, setSearchString] = React.useState('');
  const [isShowDateTimeTooltip, setDateTimeTooltip] = React.useState(false);
  const [fileLinksData, setFileLinksData] = React.useState(null);


  const ref = React.useRef();
  const curentSchedule = _.find(context.eventDetail.schedules, (s: {}): {} => _.toString(s.event_id) === _.toString(eventId));

  useOutsideClick(ref, () => {
    handleShowExportDrop(false);
  });

  const handleSearchInput = (e: any) => {
      const val = e.target.value;

      setSearchString(val);
      handleDateTimeTooltip(val);
      debouncedChangeHandler(val);
  };

  const handleSubmitSearch = (val: any) => {
    handleSearch(val);
  };

  const debouncedChangeHandler = React.useMemo(
    () => _.debounce(handleSubmitSearch, 700)
  , []);

  const handleDateTimeTooltip = (val: any) => {
    const number = parseInt(val);

    setDateTimeTooltip(!isNaN(number));
  };

  const handleGetExportFiles = (fileFormat: string) => {
    CssPinner(document.querySelector('body'), true);

    exportAttendees(eventId, curentSchedule.id, subViewTab, fileFormat).then((data: string[]) => {
      if (!!data) {
        setFileLinksData({
          fileLinks: data,
          fileType: fileFormat
        });
      }

      CssPinner(document.querySelector('body'), false);
    });
  };

  const handleClearLinksData = () => {
    setFileLinksData(null);
  };

  return (
    <div className="container-fluid search-bar">
      <div className="s-table">
        <div className="s-cell">
          <div className="navbar-form" style={{ float:'none', padding:0 }} role="search">
            <div className="input-group event-search green" style={{ width:'100%' }}>
              <input
                className="form-control"
                type="text"
                placeholder="search"
                autoComplete="off"
                onChange={(e: SyntheticInputEvent<HTMLInputElement>): any => {
                  e.persist();
                  handleSearchInput(e);
                }}
              />
              <span className='input-group-btn' style={{ width:'30px' }}>
                <button
                  type="button"
                  className="btn btn-default btn-search"
                >
                  <span className="icon icon-search" />
                </button>
              </span>

            <CTooltipText styles={{ visibility: isShowDateTimeTooltip ? 'visible' : 'hidden' }}>
                Please use <span style={{ color:'#e22753' }}>MM/DD/YY</span> format for dates
            </CTooltipText>
            </div>
          </div>
        </div>

        <div className="s-cell s-cell-buttons" style={{ width: '1%' }}>
          <ul className="nav">
            <li style={{ marginRight: '1rem' }}>
              {!subViewTab || subViewTab === '' ?
                <>
                  <a
                    href="#"
                    onClick={(e: SyntheticEvent<HTMLLinkElement>) => {
                      e.preventDefault();
                      handleShowtableViewModal(!showtableViewModal);
                    }}
                  >
                    <i className="icon icon-columns" style={{ verticalAlign:'middle', marginRight: '1rem' }} />
                    <span>Table View</span>
                  </a>
                  <EventPageDetailCustomersModal
                    isOpen={showtableViewModal}
                    handleShowtableViewModal={handleShowtableViewModal}
                    handleTriggerChangeTableContent={handleTriggerChangeTableContent}
                    setRowsFilter={setRowsFilter}
                    rowsFilter={rowsFilter}
                  />
                </> : null
              }

              {subViewTab === 'payments' ?
                <a
                  href={`${process.env.PROXY_API_HOST}/1/events/${eventId}/payout_summary/export?access_token=${Credentials.getToken()}`}
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  <i className="icon icon-paper" style={{ marginRight: '1rem' }} />
                  <span>Closing Report</span>
                </a> : null
              }
            </li>

            <li className={`dropdown ${showExportDrop ? 'open' : ''}`} ref={ref}>
              <a
                href="#"
                className="dropdown-toggle"
                style={{ width:'170px' }}
                data-toggle="dropdown"
                role="button"
                aria-haspopup="true"
                aria-expanded="false"
                onClick={(e: SyntheticEvent<HTMLLinkElement>) => {
                  e.preventDefault();
                  handleShowExportDrop(!showExportDrop);
                }}
              >
                <i className="icon icon-download" style={{ marginRight: '1rem' }} />
                <span>Export Table</span>
                <span className="caret" style={{ marginLeft: '1rem' }} />
              </a>

              {showExportDrop ?
                <ul className="dropdown-menu">
                  <li>
                    <a
                      href="#"
                      onClick={(e: any) => {
                        e.preventDefault();
                        handleGetExportFiles('html');
                      }}
                    >
                      <span>HTML </span>
                    </a>
                  </li>
                  <li>
                    <a
                      href="#"
                      onClick={async (e: any) => {
                        e.preventDefault();

                        handleGetExportFiles('csv');
                      }}
                    >CSV</a>
                  </li>
                  {!subViewTab &&
                    <li>
                      <a
                        href="#"
                        onClick={(e: any) => {
                          e.preventDefault();
                          handleGetExportFiles('pdf');
                        }}
                      >PDF</a>
                    </li>
                  }
                </ul> : null
              }
            </li>
          </ul>
        </div>
      </div>
      {!!fileLinksData &&
        <EventPageDetailLinksModal
          fileLinksData={fileLinksData}
          tabName={subViewTab ? subViewTab : 'tickets'}
          handleClearLinksData={handleClearLinksData}
        />
      }
    </div>
  );
};

export default EventPageDetailCustomersSearchbar;
